import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import {http, api, config} from '../../common/common';

const styles = (theme) => {
    return {
        paper: {
            width: 600,
            height: 192,
        },
        container: {
            width: '100%',
            height: '100%',
        },
        titleContainer: {
            height: 28,
            paddingTop: 24,
            paddingLeft: 24,
            paddingRight: 24,
            paddingBottom: 16,
        },
        subTitleContainer: {
            paddingTop: 0,
            paddingLeft: 24,
            paddingRight: 24,
            paddingBottom: 16,
        },
        contentContainer: {
            paddingTop: 0,
            paddingLeft: 24,
            paddingRight: 24,
            paddingBottom: 32,
        },
        titleText: {
            height: 28,
            lineHeight: '28px',
            float: 'left',
            fontSize: 24,
            color: theme.palette.text.primary,
        },
        titleSubText: {
            height: 28,
            lineHeight: '28px',
            float: 'left',
            marginLeft: 8,
            fontSize: 24,
            color: theme.palette.text.secondary,
            fontVariant: 'small-caps',
        },
        contentText: {
            color: theme.palette.text.secondary,
        },
        button: {
            position: 'absolute',
            right: 8,
            bottom: 8,
        },
        spinnerPlaceholder: {
            position: 'absolute',
            top: 'calc(50% - 30px)',
            left: 'calc(50% - 30px)',
            textAlign: 'center',
        },
        spinner: {
            color: theme.palette.text.disabled,
        },
    }
}

class About extends Component {
    constructor(props) {
        super(props);

        this.state = {
            webVersion: 0,
            appVersion: 0,
        };

        this._cancelToken = http.CancelToken.source();
        this._pending = false;
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        if (!this._pending && !nextState.webVersion && !nextState.appVersion) {
            return true;
        }

        return (this.props.open !== nextProps.open ||
            this.state.webVersion !== nextState.webVersion ||
            this.state.appVersion !== nextState.appVersion);
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (this.props.open && !prevProps.open) {
            if (!this.state.webVersion || !this.state.appVersion) {
                this._requestVersion();
            }
        }
    }

    componentWillUnmount = () => {
        if (this._cancelToken) {
            this._cancelToken.cancel();
        }
    }

    render = () => {
        const {classes} = this.props;

        const dialogClasses = {
            paper: classes.paper,
        };

        return (
            <Dialog
                classes={dialogClasses}
                fullWidth={true}
                disableBackdropClick={false}
                disableEscapeKeyDown={true}
                open={this.props.open}
            >
                {this._pending ? this._renderSpinner() : this._renderContent()}
            </Dialog>
        );
    }

    _renderContent = () => {
        const {classes} = this.props;

        return (
            <div className={classes.container}>
                <div className={classes.titleContainer}>
                    <Typography
                        className={classes.titleText}
                        variant='h6'
                    >
                        ALPHA2
                    </Typography>
                    <Typography
                        className={classes.titleSubText}
                        variant='h6'
                    >
                        - product of adatos.ai
                    </Typography>
                </div>
                <div className={classes.subTitleContainer}>
                    <Typography
                        className={classes.contentText}
                        gutterBottom={true}
                    >
                        Copyright &copy; 2018, Adatos Pte Ltd. All Rights Reserved.
                    </Typography>
                </div>
                <div className={classes.contentContainer}>
                    <Typography
                        className={classes.contentText}
                        gutterBottom={true}
                    >
                        Web version: {config.buildVersion}
                    </Typography>
                    <Typography
                        className={classes.contentText}
                        gutterBottom={true}
                    >
                        App version: {this.state.appVersion ? this.state.appVersion : 'Unknown'}
                    </Typography>
                </div>
                <Button
                    className={classes.button}
                    color='secondary'
                    autoFocus={true}
                    onClick={this._handleOk}
                >
                    Close
                </Button>
            </div>
        );
    }

    _renderSpinner = () => {
        const {classes} = this.props;

        return (
            <div className={classes.spinnerPlaceholder}>
                <CircularProgress
                    className={classes.spinner}
                    size={60}
                />
            </div>
        );
    }

    _handleOk = () => {
        if (this.props.onOk) {
            this.props.onOk();
        }
    }

    _requestVersion = async () => {
        try {
            this._pending = true;

            const response = await http.get(api.profile() + '/version', {
                params: {
                    'access_code': this.props.getAccessCode(),
                },
                cancelToken: this._cancelToken.token,
            });

            this._pending = false;
            this.setState({
                webVersion: response.data.web_version,
                appVersion: response.data.app_version,
            });
        } catch (error) {
            if (http.isCancel(error)) {
                return;
            }

            this._pending = false;
            this.setState({
                webVersion: 0,
                appVersion: 0,
            });
        }
    }
}

About.propTypes = {
    getAccessCode: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    onOk: PropTypes.func,
    onError: PropTypes.func,
}

export default withStyles(styles)(About);
